'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getClientIp = function getClientIp(req) {
  var clientIp = void 0;
  if (req && req.headers) {
    var ip = req.headers['x-forwarded-for'] || req.connection.remoteAddress;

    // in dev, loopback is sometimes an ipv6 address... downstream services
    // don't handle that well.
    if (ip === '::1') ip = '8.8.8.8';

    clientIp = ip ? ip.split(',')[0] : null;
  }
  return clientIp;
};

exports.default = getClientIp;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/getClientIp.js
// module id = 716
// module chunks = 11